import React, { useCallback } from 'react'
import { observer } from 'mobx-react'
import rootStore from '../../../../store/RootStore'
import CustomCheckbox from '../../../ui/CustomCheckbox'

const ACLRoleControl = observer(({ reportId, roleId, userId }) => {
  const {
    accessControlStore: { acl, toggleRoleAccessAtProduct },
  } = rootStore

  const handleChange = useCallback(() => {
    toggleRoleAccessAtProduct(reportId, roleId, userId)
  }, [reportId, roleId, toggleRoleAccessAtProduct, userId])

  const hasPermission =
    acl[reportId]?.roles[roleId]?.users[userId] === undefined
      ? true
      : acl[reportId]?.roles[roleId]?.users[userId]

  return (
    <CustomCheckbox
      isChecked={hasPermission}
      data-testid="acl-toggle-control"
      onChange={handleChange}
    />
  )
})

ACLRoleControl.propTypes = {}

export default ACLRoleControl
